<template>
  <!-- 积分商城-兑换记录 -->
  <div class="exchange_records">
    <!-- 头部表单查询 -->
    <input-form :inputData="inputData" @toParentVal="searchForm" :btnPosition1="true" :pageName="pageName" style="margin: 20px 0"></input-form>

    <el-button @click="getphone()" type="primary" style="margin-bottom: 13px;">导出</el-button>

    <!-- 表格 -->
    <el-table
      v-loading="talbeLoading"
      :data="tableData"
      style="width: 100%; margintop: 20px"
      :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
      :cell-style="{ 'text-align': 'left' }"
    >
      <template slot="empty">
        <div>
          <img src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png" />
          <span style="margin-left: -140px">暂无任何数据</span>
        </div>
      </template>
      <el-table-column prop="memberNick" label="客户昵称" width="200"> </el-table-column>
      <el-table-column prop="prizeName" label="礼品名称" width="200"> </el-table-column>
      <el-table-column label="礼品类型" width="200">
        <template slot-scope="scope">
          <span v-if="scope.row.prizeType == 1"> 优惠券 </span>
          <span v-if="scope.row.prizeType == 3"> 实物 </span>
        </template>
      </el-table-column>
      <el-table-column prop="point" label="消耗积分" width="200"> </el-table-column>
      <el-table-column prop="exchangeTime" label="兑换时间" width="250"> </el-table-column>
      <el-table-column label="兑换状态" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.exchangeStatus == 1"> <i class="y1"></i>兑换成功</span>
          <span v-if="scope.row.exchangeStatus == 2">
            <i class="y2"></i>
            兑换失败
            <img src="../../assets/images/ask.png" alt="" class="questionMark" />
          </span>
          <span v-if="scope.row.exchangeStatus == 3"> <i class="y1"></i>领取成功</span>
        </template>
      </el-table-column>
      <el-table-column prop="receiverName" label="收货人" width="250">
        <template slot-scope="scope">
          <div class="open">
            {{ scope.row.receiverName }}
            <div
              class="openHover"
              v-if="scope.row.receiverName && scope.row.receiverName.indexOf('*') != -1"
              @click="handleDecrypt('receiverName', scope.row, scope.$index)"
            >
              展开
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="receiverAddress" label="收货信息" width="250">
        <template slot-scope="scope">
          <div class="open">
            {{ scope.row.receiverAddress }}
            <div
              class="openHover"
              v-if="scope.row.receiverAddress && scope.row.receiverAddress.indexOf('*') != -1"
              @click="handleDecrypt('receiverAddress', scope.row, scope.$index)"
            >
              展开
            </div>
          </div>
        </template>
      </el-table-column>
      <!-- 收件人手机号 -->
      <el-table-column prop="receiverMobile" label="收件人手机号" width="210">
        <template slot-scope="scope">
          <div class="open">
            {{ scope.row.receiverMobile }}
            <div
              class="openHover"
              v-if="scope.row.receiverMobile && scope.row.receiverMobile.indexOf('*') != -1"
              @click="handleDecrypt('receiverMobile', scope.row, scope.$index)"
            >
              展开
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <span
            v-if="scope.row.deliveryStatus == 1"
            class="delivery"
            v-zoom="{ from: pageName + '兑换记录', name: '标记发货' }"
            @click="changeShip(scope.row)"
          >
            标记发货
          </span>
          <span class="delivery" v-if="scope.row.deliveryStatus == 2">
            已发货
          </span>
          <span v-if="scope.row.deliveryStatus == 3"> - </span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 表格分页 -->
    <el-pagination
      style="text-align: right; margin-top: 20px"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 30, 50, 100, 500]"
      :page-size="formDataList.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalNum"
      :current-page="formDataList.current"
    ></el-pagination>

    <el-dialog
      title="身份验证"
      width="600px"
      :show-close="false"
      custom-class="system-dialog"
      :visible.sync="visible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <!-- <div class="tip-box">
        <i class="el-icon-warning warning-icon"></i>
        <span>请填写您的联系方式，以便接收店铺营销数据、异常信息通知</span>
      </div> -->
      <div class="form-box">
        <div class="form-item">
          <div class="item-label">手机号：</div>
          <div class="item-value">
            <el-input disabled placeholder="请输入..." v-model="phone" style="width: 280px"></el-input>
          </div>
        </div>
        <div class="form-item">
          <div class="item-label">验证码：</div>
          <div class="item-value">
            <el-input placeholder="请输入" v-model="code" style="width: 170px; margin-right: 12px"></el-input>
            <el-button type="primary" :disabled="codeDisabled" @click="getCode">{{ codeMsg }}</el-button>
          </div>
        </div>
        <div class="form-item" style="margin-bottom: 8px">
          <div class="form-item" style="margin-bottom: 8px">
            <div class="item-label"></div>
            <div class="item-value">
              <div class="tip-box" style="background: #fff"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="save-btn">
        <!-- <el-button type="primary" @click="savePhone">立即保存</el-button> -->

        <button class="keepBtn" @click="savePhone()">
          确定
        </button>
        <button class="backBtn" @click="visible = false">取消</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import inputForm from "../../components/inputForm";
import { getExchangeActivityRecord } from "@/api/integralCenter/PointActivityAnalyticController";
import { changeStatus, getmoble, getSellerCheckCode, exportRecord } from "@/api/paradiseAndTaskCommonController.js";

export default {
  components: {
    inputForm,
  },
  data() {
    return {
      talbeLoading: false,
      pageName: "忠诚度管理-积分商城",
      // 表单配置项
      inputData: [
        {
          name: "客户昵称：",
          val: "memberNick",
          placeholder: "请输入礼品名称",
        },
        {
          name: "客户pin：",
          val: "pin",
          placeholder: "请输入礼品名称",
        },
        {
          name: "礼品名称：",
          val: "prizeName",
          placeholder: "请填入活动名称",
        },
        {
          name: "兑换时间：",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: true,
        },
        {
          name: "发放状态：",
          val: "deliveryStatus",
          placeholder: "请选择",
          selectArr: [
            { label: "待发货", id: 1 },
            { label: "已发货", id: 2 },
            { label: "无需发货", id: 3 },
          ],
        },
        {
          name: "礼品类型：",
          val: "prizeType",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "优惠券", id: 1 },
            { label: "实物", id: 3 },
          ],
        },
        {
          name: "兑换状态：",
          val: "exchangeStatus",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "兑换成功", id: 1 },
            { label: "兑换失败", id: 2 },
          ],
        },
      ],
      //表格数据
      tableData: [],
      formDataList: {
        current: 1,
        // endTime: "2032-09-30 00:00:00",
        // exchangeStatus: null,
        // memberNick: null,
        // pin: null,
        // prizeName: null,
        // prizeType: 1,
        size: 10,
        // startTime: "2010-09-20 00:00:00",
      },
      totalNum: 0,
      mytimestart: "",
      mytimeend: "",
      opentime: true,
      visible: false,
      phone: "",
      code: "",
      timer: null, //验证码定时
      successMsg: "",
      countdown: 60, // 倒计时s
      codeMsg: "获取验证码", // 按钮上的文字
      saveDisable: false,
      codeDisabled: false,
    };
  },
  mounted() {
    this.time();
    this.getList();
  },
  methods: {
    async getphone() {
      this.code = "";
      const { data: res } = await getmoble();
      this.visible = true;
      this.phone = res.mobile;
      this.countdown = 60;
      this.codeDisabled = false;
      this.codeMsg = "获取验证码"; // 按钮上的文字
      clearInterval(this.timer);
      this.timer = null;
      // console.log(this.formDataList, 9999);
    },
    savePhone() {
      // if (!this.phone) {
      //   this.$message.warning("请输入手机号");
      //   return;
      // }
      if (!this.code) {
        this.$message.warning("请输入验证码");
        return;
      }

      exportRecord({ ...this.formDataList, code: this.code }).then((res) => {
        if (res.code == 1) {
          var blob = new Blob([res.blob]);
          var link = document.createElement("a"); //a标签下载
          link.href = window.URL.createObjectURL(blob);
          link.download = "互动商城.xls";
          link.click();
          window.URL.revokeObjectURL(link.href);
        } else {
          this.$message.warning(res.message);
        }
      });
    },

    /** 获取验证码 */
    getCode() {
      if (!this.timer) {
        getSellerCheckCode().then((res) => {
          if (res.code == 1) {
            this.codeDisabled = true;
            this.timer = setInterval(() => {
              if (this.countdown > 0 && this.countdown <= 60) {
                this.countdown--;
                if (this.countdown !== 0) {
                  this.codeMsg = "重新发送(" + this.countdown + ")";
                } else {
                  clearInterval(this.timer);
                  this.codeMsg = "获取验证码";
                  this.countdown = 60;
                  this.timer = null;
                  this.codeDisabled = false;
                }
              }
            }, 1000);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },

    //加密
    handleDecrypt(name, objdata, item, index) {
      let params = "";
      // 资料明细 userInfoTable  实物奖品 inkindTable
      if (objdata == "userInfoTable") {
        params = "encrypt" + name[0].toUpperCase() + name.substring(1, name.length);
      } else if (objdata == "inkindTable") {
        params = "decrypt" + name[0].toUpperCase() + name.substring(1, name.length);
      }
      this.$decrypt.decrypt({ decryptContent: item[`${params}`] }).then((res) => {
        this[`${objdata}`][index][`${name}`] = res.message;
      });
    },
    //时间拼装
    time() {
      // let yy = new Date().getFullYear(); //当前年份
      // let mm = new Date().getMonth() + 1 < 10 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1;
      // let dd = new Date().getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate(); //当前天数
      // this.mytimestart = `${yy}-${mm}-${dd} 00:00:00`;
      // this.mytimeend = `${yy}-${mm}-${dd} 23:59:59`;

      this.mytimestart = this.getDateStr(-30) + " 00:00:00";
      this.mytimeend = this.getDateStr(0) + " 23:59:59";
    },
    getList() {
      this.talbeLoading = true;
      if (this.opentime == true) {
        this.formDataList.startTime = this.mytimestart;
        this.formDataList.endTime = this.mytimeend;
        this.opentime = false;
      }
      getExchangeActivityRecord(this.formDataList).then((res) => {
        this.tableData = res.data.records;
        console.log(this.tableData);
        this.talbeLoading = false;
        this.totalNum = Number(res.data.total);
      });
    },
    // 表单查询
    searchForm(val) {
      this.formDataList = val;
      this.formDataList.size = 10;
      this.formDataList.current = 1;
      this.getList();
    },
    //标记发货
    changeShip(row) {
      // let id = row.id;
      console.log(row);
      this.$confirm("是否标记为发货?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(() => {
        changeStatus(row.id)
          .then((res) => {
            if (res && res.code == 1) {
              this.$message.success(res.message);
              this.getList();
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((res) => {});
      });
    },
    //分页事件
    handleSizeChange(val) {
      this.formDataList.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.formDataList.current = val;
      this.getList();
    },
    // 点击解密
    handleDecrypt(name, item, index) {
      let params = "encrypt" + name[0].toUpperCase() + name.substring(1, name.length);

      this.$decrypt.decrypt({ decryptContent: item[`${params}`] }).then((res) => {
        this.tableData[index][`${name}`] = res.message;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.backBtn {
  margin-left: 20px;
  width: 98px;
  height: 32px;
  color: #666666;
  border-radius: 3px;
  border: 1px solid #dddddd;
  background-color: #fff;
  &:hover {
    color: #7b61ff;
    border: 1px solid #7b61ff;
    background-color: #fff4f4;
  }
  &:active {
    color: #7b61ff;
    border: 1px solid #7b61ff;
    background-color: #fff4f4;
  }
}
.keepBtn {
  width: 98px;
  height: 32px;
  border-radius: 3px;
  background-color: #7b61ff;
  color: #fff;
  &:hover {
    opacity: 0.9;
  }
}
/deep/.system-dialog {
  .el-dialog__body {
    padding: 16px 30px 30px 30px;
  }
  .form-box {
    padding-top: 16px;
    .form-item {
      font-size: 14px;
      color: #333;
      margin-bottom: 12px;
      .item-label {
        display: inline-block;
        width: 76px;
        text-align: right;
      }
      .item-value {
        display: inline-block;
      }
    }
  }
  .save-btn {
    text-align: center;
  }
}
.tip-box {
  padding-left: 24px;
  text-align: left;
  line-height: 21px;
  font-size: 14px;
  // margin-top: 12px;
  color: #999999;
  background: #fafafa;
  position: relative;
  // margin: 20px 28px 20px 28px;
  line-height: 42px;
  .warning-icon {
    color: #fe8f8a;
    font-size: 14px;
    position: absolute;
    left: 5px;
    top: 13px;
  }
}
.exchange_records {
  box-sizing: border-box;
  padding: 20px 28px 30px;
  .y1,
  .y2 {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 5px;
  }
  .y1 {
    background-color: #7f85e9;
  }
  .y2 {
    background-color: #7b61ff;
  }
  .questionMark {
    //   height: 20px;
    margin-bottom: -3px;
    cursor: pointer;
  }
  .delivery {
    cursor: pointer;
    color: #7f85e9;
    &:hover {
      color: #7b61ff;
    }
  }
}
</style>
